import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _b6f39c20 = () => interopDefault(import('../../../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _1f13235c = () => interopDefault(import('../../../pages/account/billing.vue' /* webpackChunkName: "pages/account/billing" */))
const _276f65bf = () => interopDefault(import('../../../pages/account/crm.vue' /* webpackChunkName: "pages/account/crm" */))
const _c7ca4240 = () => interopDefault(import('../../../pages/account/manage-members.vue' /* webpackChunkName: "pages/account/manage-members" */))
const _554fc022 = () => interopDefault(import('../../../pages/account/organization.vue' /* webpackChunkName: "pages/account/organization" */))
const _1380aa0b = () => interopDefault(import('../../../pages/account/plans.vue' /* webpackChunkName: "pages/account/plans" */))
const _3aa51a92 = () => interopDefault(import('../../../pages/account/settings.vue' /* webpackChunkName: "pages/account/settings" */))
const _2c72ca12 = () => interopDefault(import('../../../pages/callback.vue' /* webpackChunkName: "pages/callback" */))
const _45c42f62 = () => interopDefault(import('../../../pages/charts.vue' /* webpackChunkName: "pages/charts" */))
const _04b77b00 = () => interopDefault(import('../../../pages/create-amp.vue' /* webpackChunkName: "pages/create-amp" */))
const _365a6fd2 = () => interopDefault(import('../../../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _3218a15a = () => interopDefault(import('../../../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _d28df8cc = () => interopDefault(import('../../../pages/dashboard/drafts.vue' /* webpackChunkName: "pages/dashboard/drafts" */))
const _0e45a05f = () => interopDefault(import('../../../pages/dashboard/favorites.vue' /* webpackChunkName: "pages/dashboard/favorites" */))
const _79f63610 = () => interopDefault(import('../../../pages/dashboard/live-amps.vue' /* webpackChunkName: "pages/dashboard/live-amps" */))
const _33dfdd28 = () => interopDefault(import('../../../pages/dashboard/plugins.vue' /* webpackChunkName: "pages/dashboard/plugins" */))
const _868b3960 = () => interopDefault(import('../../../pages/dashboard/search.vue' /* webpackChunkName: "pages/dashboard/search" */))
const _2a5af028 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _1b6036b4 = () => interopDefault(import('../../../pages/rte.vue' /* webpackChunkName: "pages/rte" */))
const _884f3ab6 = () => interopDefault(import('../../../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _212ae4d5 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5d1f1f09 = () => interopDefault(import('../../../pages/builder/_id.vue' /* webpackChunkName: "pages/builder/_id" */))
const _b7926144 = () => interopDefault(import('../../../pages/review-document/_id.vue' /* webpackChunkName: "pages/review-document/_id" */))
const _777608c8 = () => interopDefault(import('../../../pages/amp/_id/insights.vue' /* webpackChunkName: "pages/amp/_id/insights" */))
const _0e4d0d89 = () => interopDefault(import('../../../pages/amp/_id/insights-report.vue' /* webpackChunkName: "pages/amp/_id/insights-report" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _b6f39c20,
    name: "account",
    children: [{
      path: "billing",
      component: _1f13235c,
      name: "account-billing"
    }, {
      path: "crm",
      component: _276f65bf,
      name: "account-crm"
    }, {
      path: "manage-members",
      component: _c7ca4240,
      name: "account-manage-members"
    }, {
      path: "organization",
      component: _554fc022,
      name: "account-organization"
    }, {
      path: "plans",
      component: _1380aa0b,
      name: "account-plans"
    }, {
      path: "settings",
      component: _3aa51a92,
      name: "account-settings"
    }]
  }, {
    path: "/callback",
    component: _2c72ca12,
    name: "callback"
  }, {
    path: "/charts",
    component: _45c42f62,
    name: "charts"
  }, {
    path: "/create-amp",
    component: _04b77b00,
    name: "create-amp"
  }, {
    path: "/dashboard",
    component: _365a6fd2,
    children: [{
      path: "",
      component: _3218a15a,
      name: "dashboard"
    }, {
      path: "drafts",
      component: _d28df8cc,
      name: "dashboard-drafts"
    }, {
      path: "favorites",
      component: _0e45a05f,
      name: "dashboard-favorites"
    }, {
      path: "live-amps",
      component: _79f63610,
      name: "dashboard-live-amps"
    }, {
      path: "plugins",
      component: _33dfdd28,
      name: "dashboard-plugins"
    }, {
      path: "search",
      component: _868b3960,
      name: "dashboard-search"
    }]
  }, {
    path: "/login",
    component: _2a5af028,
    name: "login"
  }, {
    path: "/rte",
    component: _1b6036b4,
    name: "rte"
  }, {
    path: "/signup",
    component: _884f3ab6,
    name: "signup"
  }, {
    path: "/",
    component: _212ae4d5,
    name: "index"
  }, {
    path: "/builder/:id?",
    component: _5d1f1f09,
    name: "builder-id"
  }, {
    path: "/review-document/:id?",
    component: _b7926144,
    name: "review-document-id"
  }, {
    path: "/amp/:id?/insights",
    component: _777608c8,
    name: "amp-id-insights"
  }, {
    path: "/amp/:id?/insights-report",
    component: _0e4d0d89,
    name: "amp-id-insights-report"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
